import { ThreeDots } from 'react-loader-spinner';

function LoadingSpinner() {
    return (
        <div className="w-[120px] flex items-center justify-center overflow-hidden">
            <ThreeDots
                height="24"
                radius="9"
                color="#4fa94d"
                ariaLabel="three-dots-loading"
                visible={true}
            />
        </div>
    );
}

export default LoadingSpinner;
